import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CustomTranslateService implements TranslateLoader {

  constructor(private httpClient: HttpClient) { }

  getTranslation(lang: string): Observable<any> {
    const normalizedLang = lang.toLowerCase();
    // console.log(`Loading translation for: ${normalizedLang}`);
    return this.httpClient.get(`assets/i18n/${normalizedLang}/translate.json`).pipe(
      catchError((error) => {
        console.error(`Error loading translation file for language: ${normalizedLang}`, error);
        return of({});
      })
    );
  }

}
